{
  "aboutCluster": "About cluster",
  "businessCode": "Business code (legal owner)",
  "businessCodeInfoText": "This is filled in automatically when the organization number of the legal owner is filled in.",
  "cluster": "Cluster",
  "clusterManagement": "Cluster management",
  "clusterName": "Cluster name",
  "clusterStatus": "Cluster status",
  "dateOfFoundation": "Date of foundation",
  "legalOwner": "Legal owner",
  "legalOwnerOrgnumber": "Organization number of legal owner",
  "mainContact": "Main contact",
  "membershipFee": "Membership fee",
  "statistics.inKindCost": "Total in kind for members over time",
  "statistics.live": "Live statistics",
  "yourProfile": "Your profile"
}
